import app from './app';
import queries from './queries';
import account from './account';
import debug from './debug';
import profile from './profile';
import prefs from './prefs';
import modals from './modals';
import notifications from './notifications';
import budgets from './budgets';
import tutorial from './tutorial';
import user from './user';

export default {
  app,
  queries,
  account,
  debug,
  profile,
  prefs,
  modals,
  notifications,
  budgets,
  tutorial,
  user
};
